<template>
  <div>
    <list row-key="MealId" ref="list" unit="餐次" :show-checkbox="true" :get-data-func="api.list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column prop="MealName" label="餐次名称" min-width="120px" />
        <el-table-column prop="StartTime" label="开始时间" min-width="120px" />
        <el-table-column prop="EndTime" label="结束时间" min-width="120px" />
        <template v-if="$permission.canWrite()">
          <el-table-column label="操作" fixed="right" align="center" width="60">
            <template slot-scope="{row}">
              <el-button type="text" @click="edit(row)">编辑</el-button>
            </template>
          </el-table-column>
        </template>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import editDialog from "./editDialog";

export default {
  mixins: [listMixin],
  components: { list, editDialog },
  data() {
    return {
      api: require("@/api/cp/meal").default,
    };
  },
  methods: {
    create() {
      this.$refs.editDialog.openCreate();
    },
    edit(row) {
      this.$refs.editDialog.openEdit(row);
    },
    delRows(ids) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.MealId;
          });
          this.api.delete({ ids }).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              this.reload();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>